<template>
  <a-card :bordered='false'>
    <div class="p-b-20">
      <p class="s_c333 fz-18 s_font_b p-b-30">账户登录信息</p>
      <div class="s_flex_ali m-b-20 ">
        <p class="width13 text-ar">用户名：</p>
        <p>{{form.account}}</p>
      </div>
      <div class="s_flex_ali">
        <p class="width13 text-ar">上次登录时间：</p>
        <p>{{form.update_time}}</p>
      </div>
    </div>
    <a-divider />
    <div class="p-b-20">
      <p class="s_c333 fz-18 s_font_b p-b-30">
        管理员信息
        <a-tooltip placement='right'>
          <template #title>
            修改登录/支付密码需先进行管理员身份验证，请谨慎设置，设置后，也可使用扫码登录！
          </template>
          <QuestionCircleOutlined class='s_c376' />
        </a-tooltip>
      </p>
      <div class="s_flex_ali m-b-20 ">
        <p class="width15 text-ar">管理员姓名：</p>
        <p class="width18 m-r-15" v-if='!nameType'>{{form.contact_name || '暂无'}}</p>
        <a-input class="width18 m-r-15" v-else v-model:value="form.contact_name" placeholder='请输入管理员姓名'></a-input>
        <a-button class="m-r-15" type="primary" v-if='nameType' v-has:safeCenterEdit='()=>onSubmit("contact_name")'>保存</a-button>
        <EditOutlined class='s_c376 fz-18' v-else v-has:safeCenterEdit='()=>{nameType = !nameType}' />
      </div>
      <div class="s_flex_ali m-b-20">
        <p class="width15 text-ar">手机号码：</p>
        <p class="width18 m-r-15" v-if='!phoneType'>{{form.contact_phone || '暂无'}}</p>
        <a-input class="width18 m-r-15" v-else v-model:value="form.contact_phone" placeholder='请输入手机号码'></a-input>
        <a-button class="m-r-15" type="primary" v-if='phoneType' v-has:safeCenterEdit='()=>onSubmit("contact_phone")'>保存</a-button>
        <EditOutlined class='s_c376 fz-18' v-else v-has:safeCenterEdit='()=>{phoneType = !phoneType}' />
      </div>
      <!-- <div class="s_flex_ali m-b-20">
        <p class="width15 text-ar">微信绑定：</p>
        <p class="width18 m-r-15">二维码营销</p>
        <EditOutlined class='s_c376 fz-18' v-if='wxType' @click='visibleBd = !visibleBd' />
        <EditOutlined class='s_c376 fz-18' v-else @click='visibleSf = !visibleSf' />
      </div> -->
      <!-- <div class="s_flex_ali s_po_re">
        <p class="width15 text-ar">账号登录需扫码确认：</p>
        <a-radio-group v-model:value="form.is_code_login">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="0">关闭</a-radio>
        </a-radio-group>
        <a-tooltip placement='right'>
          <template #title>
            若选择开启，所有账号选择密码登录时，需再次扫码确认后才可进入系统，请谨慎设置！
          </template>
          <QuestionCircleOutlined class='s_c376' />
        </a-tooltip>
        <a-button class="m-l-15" v-if='loginType' type="primary" @click='onSubmit("is_code_login")'>保存</a-button>
        <div class="s_po_ab_bl width100 height-32" v-else @click='loginType = !loginType'></div>
      </div> -->
    </div>
    <a-divider />
    <div class="p-b-20 m-b-40">
      <p class="s_c333 fz-18 s_font_b">账户安全信息</p>
      <div class="s_flex_bian_c p-b-30 p-t-30 p-l-20" style="border-bottom: 1px dashed #dfe2e5;">
        <p>登录密码</p>
        <p>强度：<span class="s_c376">中</span></p>
        <p class="width50">安全性高的密码可以使帐号更安全，建议你定期更换密码，且设置一个包含数字和字母，长度超过6位以上的密码。</p>
        <p class="width13">
          <a-button type="link" v-if='loginPassword' v-has:safeCenterEdit='()=>{visibleXg = !visibleXg;passwordName = "password"}'>修改</a-button>
          <a-button type="link" v-else v-has:safeCenterEdit='()=>{visibleSf = !visibleSf}'>修改</a-button>
        </p>
      </div>
      <div class="s_flex_bian_c p-b-30 p-t-30 p-l-20" style="border-bottom: 1px dashed #dfe2e5;">
        <p>支付密码</p>
        <p>强度：<span class="s_c376">中</span></p>
        <p class="width50">安全性高的密码可以使帐号更安全，建议你定期更换密码，且设置一个包含数字和字母，长度超过6位以上的密码。</p>
        <p class="width13">
          <a-button type="link" v-if='payPassword' v-has:safeCenterEdit='()=>{visibleXg = !visibleXg;passwordName = "pay_password"}'>修改</a-button>
          <a-button type="link" v-else v-has:safeCenterEdit='()=>{visibleSf = !visibleSf}'>修改</a-button>
        </p>
      </div>
    </div>
  </a-card>
  <!-- 身份验证 -->
  <a-modal  :keyboard="false" title="身份验证" :width='800' centered :footer="null" v-model:visible="visibleSf" destroyOnClose>
    <p class="m-b-20">
      <InfoCircleOutlined class="s_c376 m-r-5" />请选择以下一种验证方式进行管理员信息的修改</p>
    <a-radio-group v-model:value="testType" button-style="solid">
      <a-radio-button :value="1">微信验证</a-radio-button>
      <a-radio-button :value="2">手机验证</a-radio-button>
    </a-radio-group>
    <div class="s_flex_center" v-if='testType == 1'>
      <div class="p-t-40 p-b-40">
        <p class="text-ac m-b-25">请用管理员(菜鸡)微信扫描二维码进行验证</p>
        <img class="width-200 height-200 s_mauto" style="display: block;" src="../../../assets/images/user.png" alt="">
      </div>
    </div>
    <div class="p-t-40 p-b-40" v-if='testType == 2'>
      <a-form-item label="已验证手机号" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
        <p class="s_c333">185****2259</p>
      </a-form-item>
      <a-form-item label="验证码" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
        <div class="s_flex_ali width60 m-t-5">
          <a-input v-model:value="code" placeholder='请输入验证码'></a-input>
          <a-button class="m-l-10" type="primary" ghost>获取验证码</a-button>
        </div>
        <p class="m-t-5">你今天有3次获取验证码的机会</p>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
        <a-button type="primary" @click="onSubmit">完成</a-button>
      </a-form-item>
    </div>
  </a-modal>
  <!-- 修改密码 -->
  <a-modal  :keyboard="false" title="修改密码" centered :footer="null" v-model:visible="visibleXg" destroyOnClose @cancel='oldPassword="";newPassword="";againPassword=""'>
    <a-form-item label="输入原密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-input-password v-model:value="oldPassword" placeholder='请输入原密码'></a-input-password>
    </a-form-item>
    <a-form-item label="输入新密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-input-password v-model:value="newPassword" placeholder='请输入新密码'></a-input-password>
    </a-form-item>
    <a-form-item label="再次输入新密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-input-password v-model:value="againPassword" placeholder='请再次输入新密码'></a-input-password>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 6 }">
      <a-button type="primary" @click="onSubmit(passwordName)">保存</a-button>
    </a-form-item>
  </a-modal>
  <!--绑定微信号  -->
  <a-modal  :keyboard="false" title="绑定微信号" centered :width='660' :footer="null" v-model:visible="visibleBd" destroyOnClose>
    <p class="m-b-20">
      <InfoCircleOutlined class="s_c376 m-r-5" />你正在修改绑定的微信号，涉及到账户安全，请不要频繁修改！</p>
    <a-form-item label="二维码" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }"
      help='请使用新管理员的微信扫描二维码，下方输入微信验证码即可更换成功。'>
      <div class="s_flex_ali p-b-20">
        <div class="width-156 height-156 s_flex_center wxcodeBox">
          <img class="width-138 height-138" :src="code" alt="">
        </div>
        <!-- <div class="height-42 s_bor_cd9 s_flex_center m-l-35 p-l-25 p-r-25">
          <ScanOutlined class="fz-18 m-r-5" />
          <p>扫码使用演示</p>
        </div> -->
      </div>
    </a-form-item>
    <a-form-item label="微信验证码" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
      <a-input v-model:value="wx_code" placeholder='请输入微信验证码'></a-input>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
      <a-button type="primary" @click="saveWxBind">保存</a-button>
    </a-form-item>
  </a-modal>
</template>
<script>
  import { InfoCircleOutlined, QuestionCircleOutlined, EditOutlined, ScanOutlined } from "@ant-design/icons-vue";
  import { getAdminCode } from "@/api/system";
  import { ref, onMounted, reactive, toRefs } from 'vue';
  import { message } from 'ant-design-vue';
  import { getRouter } from '@/utils/app';
  import { iscode } from '@/utils/app';
  import { getInfoDetail, setAccountInfoUpdate,userInit } from "@/api/system";
  import store from '@/store'
  // 初始化默认筛选项数值
  let defForm = {
    password: '',
    contact_name: '',
    contact_phone: '',
    field: '',
    pay_password: '',
    is_code_login: 0
  }
  export default {
    components: { InfoCircleOutlined, QuestionCircleOutlined, EditOutlined },
    setup(props) {
      // // 初始化 分页信息和筛选项信息
      const form = ref({ ...defForm });
      const state = reactive({
        testType: 1,
        code: '',
        oldPassword: '',
        newPassword: '',
        againPassword: '',
        passwordName:'',
        visibleSf: false,
        visibleXg: false,
        visibleBd: false,
        nameType: false,
        phoneType: false,
        wxType: true,
        loginType: true,
        loginPassword: true,
        payPassword: true,
        visibleModel:false
      });
      //获取详情
      const getMore = async (id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getInfoDetail().then(res => res.data);
        if (iscode(res)) {
          form.value = res.data
          state.address = [res.data.province, res.data.city, res.data.region]
          setTimeout(hide);
        } else {
          setTimeout(hide);
          message.error(res.msg);
        }
      }
          // 获取绑定二维码
    const code=ref()
    const adminCode=async()=>{
      let result=await getAdminCode().then(res=>res.data).catch(error=>error)
        code.value=result.data.url
    }
    adminCode()
      const onSubmit = async(name) =>{
        if(state.newPassword!=state.againPassword){
          message.error('两次新密码不一致')
          return
        }
        const hide = message.loading('正在加载中...', 0);
        if(name == 'password'){
          form.value.old_password = state.oldPassword
          form.value.password = state.newPassword
          form.value.re_password = state.againPassword
        }
        if(name == 'pay_password'){
          form.value.old_pay_password = state.oldPassword
          form.value.pay_password = state.newPassword
          form.value.re_pay_password = state.againPassword
        }
        let res = await setAccountInfoUpdate({...form.value,field:name,}).then(res => res.data);
        if (iscode(res,true)) {
          state.oldPassword = ''
          state.newPassword = ''
          state.againPassword = ''
          state.visibleXg = false
        } 
        setTimeout(hide);
      }
      const wx_code=ref()
      const saveWxBind=async()=>{
           let result=await userInit({code:wx_code.value}).then(res=>res.data).catch(error=>error)
           console.log(result)
      }
      onMounted(() => {
        getMore();
      });
      return {
        ...toRefs(state),
        form,
        onSubmit,
        confirm,
        code,
        saveWxBind,
        wx_code
      };
    },
  };
</script>
<style lang="less" scoped>
  .wxcodeBox {
    background-image: url('../../../assets/images/erweima-box.png');
    background-size: 100% 100%;
  }
</style>